module.exports = __webpack_public_path__ + "img/CustomROM.5dde0578.png";